export enum TriState {
   TRUE,
   FALSE,
   INDETERMINATE
}
